import React, { useContext } from 'react'

import { Button, Form, Input, TextArea } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter,ModalTitle } from '@driftt/tide-modal'

import { toggleUserProperty } from 'api'
import { CurrentUserContext } from 'context/currentUserContext'
import { segmentTrack,TrackType } from 'utils/tracking'

import styles from './styles.module.css'

interface FeedbackModalProps {
  onClose: () => void
  onSubmit?: () => void
}

const USER_PROPERTY = 'HAS_SEEN_PROSPECTOR_FEEDBACK_FORM'

const DIFFICULTY = {
  veryDifficult: 1,
  somewhatDifficult: 2,
  neutral: 3,
  somewhatEasy: 4,
  veryEasy: 5
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ onClose, onSubmit }) => {
  const currentUser = useContext(CurrentUserContext)
  const [rating, setRating] = React.useState(undefined)
  const [feedback, setFeedback] = React.useState(undefined)
  const isValid = rating !== undefined

  const onRadioClick = (value: any) => {
    setRating(value)
  }

  const onTextChange = (e: any) => {
    setFeedback(e.target.value)
  }

  const dismissAndClose = () => {
    currentUser && toggleUserProperty(currentUser?.id, USER_PROPERTY, true)
    onClose()
  }

  const handleSubmit = () => {
    segmentTrack(TrackType.SUBMITTED_FEEDBACK_FORM, {
      email: currentUser?.email,
      orgId: currentUser?.orgId,
      rating,
      feedback,
      userId: currentUser?.id
    })
    onSubmit && onSubmit()
    dismissAndClose()
  }

  return (
    <Modal open={true} size="medium" onClose={dismissAndClose} className={styles.feedbackModal}>
      <ModalTitle className={styles.modalHeader}>
        How difficult or easy are Drift’s account activity features to use?
      </ModalTitle>
      <ModalBody>
        <Form className={styles.feedbackForm} onSubmit={handleSubmit}>
          <div className={styles.radioButtons}>
            <Input
              type="radio"
              className={styles.radio}
              label="Very difficult"
              onClick={() => onRadioClick(DIFFICULTY.veryDifficult)}
              checked={rating === DIFFICULTY.veryDifficult}
            />
            <Input
              type="radio"
              className={styles.radio}
              label="Somewhat difficult"
              onClick={() => onRadioClick(DIFFICULTY.somewhatDifficult)}
              checked={rating === DIFFICULTY.somewhatDifficult}
            />
            <Input
              type="radio"
              className={styles.radio}
              label="Neutral"
              onClick={() => onRadioClick(DIFFICULTY.neutral)}
              checked={rating === DIFFICULTY.neutral}
            />
            <Input
              type="radio"
              className={styles.radio}
              label="Somewhat easy"
              onClick={() => onRadioClick(DIFFICULTY.somewhatEasy)}
              checked={rating === DIFFICULTY.somewhatEasy}
            />
            <Input
              type="radio"
              className={styles.radio}
              label="Very easy"
              onClick={() => onRadioClick(DIFFICULTY.veryEasy)}
              checked={rating === DIFFICULTY.veryEasy}
            />
          </div>
          <TextArea
            label="How can we improve Drift for you?"
            placeholder="It would be great if I could..."
            onChange={onTextChange}
            value={feedback}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="primary"
          disabled={!isValid}
          onClick={handleSubmit}
          className={styles.submitButton}>
          Save
        </Button>
        <Button type="tertiary" onClick={dismissAndClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FeedbackModal
